<template>
    <v-card
        class="team-tile rounded-lg"
        :class="{ 'team-tile--mine': mine, 'team-tile--mobile': $vuetify.breakpoint.xs }"
        :style="{ '--team-color': team.color || 'orange' }"
        hover
        @click="$emit('open', team)"
    >
        <div class="team-tile__logo">
            <v-img
                v-if="team.logo"
                :src="`${assetsUrl}/${team.logo}`"
                class="team-tile__logo-img"
                contain
            />
            <v-icon v-else class="team-tile__logo-icon orange--text">mdi-basketball</v-icon>
        </div>
        <div class="team-tile__name">{{ team.name }}</div>
        <span v-if="mine" class="team-tile__mine custom-orange">Η ομάδα μου</span>
    </v-card>
</template>

<script>
    export default {
        props: {
            team: {
                type: Object,
                required: true
            },
            mine: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com'
            }
        }
    }
</script>

<style scoped>
/* Keeps the diagonal team-color design */
.team-tile {
    position: relative;
    display: flex;
    align-items: center;
    gap: 14px;
    height: 100%;
    min-height: 96px;
    padding: 10px 14px;
    background: linear-gradient(110deg, var(--team-color) 22%, #fff 22%);
    overflow: hidden;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.team-tile:hover {
    transform: translateY(-3px);
}

.team-tile--mine {
    box-shadow: 0 0 0 3px #ff7133, 0 8px 18px rgba(255, 113, 51, 0.3) !important;
}

.team-tile__logo {
    flex: 0 0 72px;
    width: 72px;
    height: 72px;
    padding: 6px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
}

.team-tile__logo-img {
    width: 100%;
    height: 100%;
}

.team-tile__logo-icon {
    font-size: 52px !important;
}

.team-tile__name {
    min-width: 0;
    color: #111;
    font-weight: 700;
    line-height: 1.25;
    word-break: break-word;
    /* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix -- the line clamp needs the prefixed box */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    /* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */
    overflow: hidden;
}

.team-tile__mine {
    position: absolute;
    top: 6px;
    right: 6px;
    padding: 1px 8px;
    border-radius: 4px;
    color: #fff;
    font-size: 0.65rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
}

/* Phone: two per row, logo on top, same stripe turned horizontal */
.team-tile--mobile {
    flex-direction: column;
    justify-content: flex-start;
    gap: 8px;
    min-height: 150px;
    padding: 14px 8px 10px;
    text-align: center;
    background: linear-gradient(180deg, var(--team-color) 40%, #fff 40%);
}

.team-tile--mobile .team-tile__logo {
    flex-basis: 64px;
    width: 64px;
    height: 64px;
}

.team-tile--mobile .team-tile__name {
    font-size: 0.85rem;
}

.team-tile--mobile .team-tile__mine {
    top: 4px;
    right: 4px;
    font-size: 0.55rem;
}
</style>
